import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/sa/game-sa/why_choose.webp";

function whychoose(props) {
  return (
    <div
      className="whychoose why_choosedubai p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>
              Why Choose TekRevol for Game Design or
              <span> Game Development</span>
            </h2>
            <p>
              As a game development company in Saudi Arabia, you can rely on us
              as we're your partners in success. We ensure to exceed your
              expectations at every step of the game design and development
              process with our commitment to excellence and innovation. Our team
              of expert game developers utilize their expertise in technology,
              creativity, and industry trends to deliver top-notch gaming
              experiences
            </p>
            <p>
              When you choose TekRevol for full game development, you're
              choosing a team that prioritizes your goals and the expectations
              of the audience above anything else. We work closely with you to
              ensure your ideas are crafted exactly as you imagined them. Core
              reasons to choose our game development company:
            </p>
            <ul>
              <li>Expertise in the latest gaming tools and technologies </li>
              <li>Customized solutions as per your specific needs</li>
              <li>Experience in delivering high-quality games</li>
              <li>Expert team of experienced game developers </li>
              <li>Commitment to ongoing support and collaboration</li>
            </ul>
            <p>
              We have a proven track record of delivering successful gaming
              projects across various platforms. So, you can trust us to turn
              your concepts into reality and scale up your gaming business in
              this competitive market.
            </p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>Apps Developed</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>Review</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>Industries Served</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
